/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinalizeTaxDeclarationCommand } from '../../models/finalize-tax-declaration-command';

export interface ApiTaxDeclarationFinalizePatch$Params {
      body: FinalizeTaxDeclarationCommand
}

export function apiTaxDeclarationFinalizePatch(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationFinalizePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationFinalizePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiTaxDeclarationFinalizePatch.PATH = '/api/TaxDeclaration/finalize';
